import { Platform } from 'react-native';
import { useState, useEffect } from 'react';

// Re-export from posthog-react-native on native platforms
// On web, returns the posthog-js instance from global

let usePostHogNative: () => any;

if (Platform.OS !== 'web') {
  try {
    const posthogRN = require('posthog-react-native');
    usePostHogNative = posthogRN.usePostHog;
  } catch (e) {
    console.warn('[usePostHog] posthog-react-native not available');
    usePostHogNative = () => null;
  }
} else {
  // Web hook - returns posthog-js instance from global or window
  usePostHogNative = () => {
    const getPostHogInstance = () => {
      if (typeof window !== 'undefined' && (window as any).posthog) {
        return (window as any).posthog;
      }
      if (typeof global !== 'undefined' && (global as any).posthog) {
        return (global as any).posthog;
      }
      return null;
    };
    
    const [posthog, setPosthog] = useState<any>(getPostHogInstance());
    
    useEffect(() => {
      // Check if PostHog is available (may be initialized async)
      const checkPostHog = () => {
        const instance = getPostHogInstance();
        if (instance && !posthog) {
          setPosthog(instance);
        }
      };
      
      // Check immediately
      checkPostHog();
      
      // Also check after a short delay in case it's still initializing
      const timeout = setTimeout(checkPostHog, 500);
      return () => clearTimeout(timeout);
    }, [posthog]);
    
    return posthog;
  };
}

export const usePostHog = usePostHogNative;
export default usePostHog;

